<template>
  <NewgameWrapper ref="newGameWrapper" :location="1" :showBottomNav="true">
    <Scroll
      ref="scroll"
      :class="[$style.box]"
      :listenScroll="true"
      :pulldown="true"
      @bsPullingDown="bsPullingDown"
    >
      <div>
        <!-- 新游推荐顶部banner -->
        <NewgameWrapperTopbanner v-if="topBannerList.length > 0" :topBannerList="topBannerList" />
        <!-- 我的游戏圈板块 -->
        <CircleBaseBox boxTitle="我的游戏圈" style="margin-top: 7px">
          <!-- 没有注册的时候显示 -->
          <div v-if="!isRegister" :class="$style['game-not-show']">
            <div :class="$style.word" style="font-size: 10px">
              您还未注册论坛账号，请先注册论坛账号哦！
            </div>
            <div :class="$style.btn" @click="handleRegister">点击前往注册</div>
            <img :src="catBack" alt="猫咪图标" />
          </div>
          <!-- 没有绑定账号时显示 -->
          <div v-if="!isBindAccount && isRegister" :class="$style['game-not-show']">
            <div :class="$style.word">您还未绑定任何游戏账号</div>
            <div :class="$style.btn" @click="bindAccount">点击前往绑定</div>
            <img :src="catBack" alt="猫咪图标" />
          </div>
          <!-- 绑定账号但激活游戏没有对应游戏圈时显示 -->
          <div
            v-if="isBindAccount && !userGameCircleFlag && isRegister"
            :class="$style['game-not-show']"
          >
            <div :class="$style.word" style="font-size: 10px">
              您当前的游戏尚未开设游戏圈，不妨试试其他热门游戏！
            </div>
            <div :class="$style.btn" @click="handleLinkTo('gameCenter.home')">点击前往游戏中心</div>
            <img :src="catBack" alt="猫咪图标" />
          </div>
          <!-- 绑定账号且激活游戏且有对应游戏圈时显示 -->
          <div
            v-if="isBindAccount && userGameCircleFlag && isRegister"
            :class="$style['game-show']"
          >
            <div :class="$style['circle-list']">
              <div
                v-for="item in userGameCircles"
                :key="item.id"
                :class="$style['circle-list-item']"
                @click="handleLinkTo('gameCircle.home', { circleId: item.id })"
              >
                <img :src="item.images" alt="游戏圈icon" />
                <div :class="$style['circle-list-name']">{{ item.name }}</div>
                <div>
                  <div>{{ '昵称：' + item.role_name }}</div>
                  <!-- <div>{{ '版本：' + item.app_name }}</div> -->
                </div>
              </div>
            </div>
          </div>
        </CircleBaseBox>
        <!-- 普通游戏圈板块 -->
        <CircleBaseBox v-for="item of circleList" :key="item.id" :boxTitle="item.name">
          <!-- 游戏圈列表横版 -->
          <GameCircleHorizontal
            v-if="item.type == 1"
            :circleList="item.game_circle"
            :plateId="item.id"
          ></GameCircleHorizontal>
          <!-- 游戏圈列表竖版 -->
          <GameCircleVertical
            v-else
            :circleList="item.game_circle"
            :plateId="item.id"
          ></GameCircleVertical>
        </CircleBaseBox>
      </div>
    </Scroll>
  </NewgameWrapper>
</template>

<script>
import NewgameWrapper from '_c/NewgameWrapper';
import NewgameWrapperTopbanner from '_c/NewgameWrapperTopbanner';
import Scroll from '_c/Scroll';
import CircleBaseBox from '_c/CircleBaseBox';
import GameCircleHorizontal from './components/GameCircleHorizontal';
import GameCircleVertical from './components/GameCircleVertical';
import { getUserGameCircles, getCircleList } from '@/api/gameCircleCenter';
import { reportData } from '@/api/report';
import { mapActions, mapState, mapMutations } from 'vuex';
import { CDN_URL } from "@/config/index.js";
export default {
  components: {
    NewgameWrapper,
    CircleBaseBox,
    GameCircleHorizontal,
    GameCircleVertical,
    NewgameWrapperTopbanner,
    Scroll
  },
  data() {
    return {
      userGameCircles: [],
      circleList: [],
      catBack: `${CDN_URL}/catBack.png?v=123`,
      isScrollTop: true
    }
  },
  computed: {
    ...mapState("account", {
      userInfo: state => state.userInfo // 当前用户信息
    }),
    ...mapState('gameCircleCenter', {
      topBannerList: state => state.topBannerList,
    }),
    // 判断是否注册论坛
    isRegister() {
      let flag = this.userInfo.forum_user_id != 0 ? true : false
      return flag;
    },
    // 判断是否绑定游戏账号
    isBindAccount() {
      let flag = this.userInfo.game_user_id != 0 ? true : false
      return flag;
    },
    // 判断激活游戏是否有对应游戏圈
    userGameCircleFlag() {
      return this.userGameCircles.length ? true : false;
    },
  },
  created() {
    this.getUserGameCircles()
    this.getCircleList()
  },
  mounted() {
    reportData({
      type: 1,
      data_type: 1, // 圈子中心首页加载
    })
  },
  methods: {
    ...mapMutations('app', {
      CHANGE_BIND_GAME: 'CHANGE_BIND_GAME',
      CHANGE_REGISTER_DIALOG: 'CHANGE_REGISTER_DIALOG'
    }),
    // 获取玩家玩过的游戏对应游戏圈列表
    async getUserGameCircles() {
      const r = await getUserGameCircles();
      this.userGameCircles = [...r.data];
    },
    // 获取游戏圈首页板块列表
    async getCircleList() {
      const r = await getCircleList();
      this.circleList = [...r.data]
    },
    // 绑定账号
    bindAccount() {
      this.CHANGE_BIND_GAME(true)
    },
    // 游戏子包名处理
    handleGameName(e) {
      try {
        let name = e.indexOf('(') == -1 ? e.split('（')[0] : e.split('(')[0];
        return name;
      } catch (error) {
        return e;
      }
    },
    // 论坛内部跳转链接
    async handleLinkTo(pathName, query) {
      if (pathName === 'gameCircle.home') {
        try {
          const r = await reportData({
            type: 1,
            data_type: 2, // 我的游戏圈-具体圈子
            circle_id: query.circleId
          })
        } catch (error) {
          console.log(error);
        }
      }
      this.$router.push({ name: pathName, query: query })
    },
    // 下拉加载
    bsPullingDown() {
      this.$refs.newGameWrapper.openNewGame()
      setTimeout(() => {
        this.$refs.scroll && this.$refs.scroll.refresh();
      }, 10);
    },
    // 点击注册
    handleRegister() {
      this.CHANGE_REGISTER_DIALOG(true)
    }
  },
}
</script>

<style lang="scss" module>
@import '~@/styles/mixins.scss';
.box {
  width: 100%;
  height: calc(100vh - 60px);
  > div {
    min-height: 100vh;
  }
}
.game-show {
  position: relative;
  width: 340px;
  height: 95px;
  padding-top: 5px;
  .circle-list {
    min-width: 340px;
    height: 95px;
    display: flex;
    .circle-list-item {
      @include vertical-center;
      flex-direction: column;
      margin-right: 23px;
      width: 68px;
      height: 95px;
      > img {
        width: 58px;
        height: 58px;
        border-radius: 12px;
      }
      .circle-list-name {
        width: 68px;
        height: 13px;
        margin-top: 4px;
        font-size: 10px;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        word-break: break-all;
        -webkit-box-orient: vertical;
        line-height: 13px;
      }
      > div {
        width: 68px;
        height: 20px;
        margin-top: 2px;
        text-align: center;
        > div {
          font-size: 8px;
          font-weight: 400;
          color: rgba(159, 159, 159, 1);
          @include ellipsis(1);
          line-height: 10px;
        }
      }
    }
  }
}
.game-not-show {
  position: relative;
  width: 340px;
  height: 100px;
  margin-top: 10px;
  .word {
    width: 100%;
    line-height: 20px;
    text-align: center;
    font-size: 14px;
    color: #d1d1d1;
  }
  .btn {
    position: absolute;
    width: 100px;
    height: 25px;
    border: 1px solid rgba(69, 175, 243, 1);
    border-radius: 12px;
    font-size: 10px;
    color: rgba(69, 175, 243, 1);
    line-height: 25px;
    text-align: center;
    top: 30px;
    left: 50%;
    transform: translateX(-50%);
  }
  > img {
    width: 301px;
    margin: 14px 0px 0px 16px;
  }
}
</style>
